import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_20: FaireProductEntity = {
  token: "legacy_prod_abbott-20",
  type: "product",
  name: "Hue Oval",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a13484b9453b5981b977bbd27084d6b35e6834ee51188fd1cddb0b855199d606.jpeg",
  priceDollars: 22,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
